const hasStorageAccess = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

export const getActiveCompanyId = () => {
  if (!hasStorageAccess()) return null;
  const stored = window.localStorage.getItem("companyId");
  if (stored == null || stored === "") return null;
  const parsed = Number(stored);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const setActiveCompanyId = (companyId) => {
  if (!hasStorageAccess()) return;
  if (companyId == null) return;
  const parsed = Number(companyId);
  if (!Number.isFinite(parsed) || parsed <= 0) return;
  window.localStorage.setItem("companyId", String(parsed));
};

export const clearActiveCompanyId = () => {
  if (!hasStorageAccess()) return;
  window.localStorage.removeItem("companyId");
};
